import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import type { ICreateTimeAssignmentResponse, IRegisterTimeAssignmentFormData } from "./types";

export const registerTimeAssignment = async (formData: IRegisterTimeAssignmentFormData[]): Promise<ICreateTimeAssignmentResponse> => {
  try {
    const response = await apiClientSource.post("/task-service/api/tasks-schedule/registry-task-schedule", formData);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al registrar la asignación de tiempo");
    throw error;
  }
};
